const exceptionHandlerDecorator = ($delegate, $injector) => {
  'ngInject';

  return (exception, cause) => {
    $injector.get('appErrorHandler').handle(exception, '', true);
    $delegate(exception, cause);
  };
};

export default exceptionHandlerDecorator;
